export const COLOR_EXTRACTION_CONFIG = {
  colorTolerance: 100,
  maxColors: 20,
} as const

